import { useEffect, useState } from "react"
import { Box, IconButton, Typography, LinearProgress, Button, Table, TableBody, TableCell, TableContainer, TableRow, Paper, TextField, FormControl, Select, MenuItem, InputLabel, SelectChangeEvent } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { DataGridPro, GridSortModel, GridFilterModel, GridLinkOperator } from '@mui/x-data-grid-pro';
import DescriptionIcon from '@mui/icons-material/Description';
import { BaseStateInformationPortalUrl, StateInformationPortalUrl } from '../Constants';
import { apiClient } from "../helper/api"
import useAuth, { authData } from "../context/AuthProvider";
import moment from "moment";
import formatPrice from "../helper/currencyFormatter";
import { AddDocument } from "./AddDocuments";
import { Link } from "react-router-dom";
import useAppDialog from "../hooks/useAppDialog";
import { DialogResponse, DialogResult } from "../components/Dialog/dialogTypes";
import Tooltip from '@mui/material/Tooltip';
import Swal from "sweetalert2";
import { safeMoment } from "../helper/utils";
import { UploadedDocumentType } from "../models/TaxTransactionReportModel";
import { writeXlsxFile } from "../helper/utils";


interface Transaction {
  rowNum: number;
  invoiceNumber: string;
  insuredName: string;
  policyNumber: string;
  homeState: string;
  transactionTypeName: string;
  invoiceDate: string;
  effectiveDate: string;
  policyExpDate: string;
  grossPremium: string;
  customerPolicyId: number;
  state: string;
  hasMessage: boolean;
  client: string;
  dueDate: string;
}

interface Partner {
  partnersId: number;
  customerName: string;
}

export const CustomerTransactions: React.FC<{ currentUser: authData | undefined }> = ({ currentUser }) => {
  // Sample data - replace with your actual data source
  const [loading, setloading] = useState(false)
  const { user } = useAuth()
  const [itemList, setItemList] = useState<Transaction[]>([])
  const [ pageSize, setPageSize] = useState(50)
  const [ pageNumber, setPageNumber] = useState(1)
  const [ totalCount, setTotalCount] = useState(0)
  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const [filterModel, setFilterModel] = useState<GridFilterModel>({ items: [], linkOperator: GridLinkOperator.And });
  const [ID, setID] = useState();
  const [openDoc, setOpenDoc] = useState(false);
  const [viewOnlyDoc, setViewOnlyDoc] = useState(false);
  const [selectedHomeState, setSelectedHomeState] = useState('');
  const [policyNumber, setPolicyNumber] = useState('');
  const [insuredName, setInsuredName] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [selectedPartner, setSelectedPartner] = useState('');
  const [clients, setClients] = useState<string[]>([]);
  const [partners, setPartners] = useState<Partner[]>([]);
  const [selectedTab, setSelectedTab] = useState<'Outstanding' | 'SentToMISC'>('Outstanding');
  const [summaryData, setSummaryData] = useState({
    pastDue: 0,
    dueToday: 0,
    dueInNext10Days: 0,
    totalOutstanding: 0,
  });

  const token = user?.token

  var headerHeight = document.getElementsByClassName('customer-header').length > 0 ? document.getElementsByClassName('customer-header')[0].clientHeight : 0;
  headerHeight = document.getElementsByClassName('img-bg-sec').length ? headerHeight + document.getElementsByClassName('img-bg-sec')[0].clientHeight : headerHeight;
  headerHeight = document.getElementsByClassName('MuiDataGrid-footerContainer').length > 0 ? headerHeight + document.getElementsByClassName('MuiDataGrid-footerContainer')[0].clientHeight : headerHeight;

  useEffect(() => {
    fetchData();
    fetchStateData();
    getPartnersList();
  }, [pageNumber, pageSize, filterModel, sortModel, selectedTab])

  // Handler for tab change - resets data and shows loading
  const handleTabChange = (tab: 'Outstanding' | 'SentToMISC') => {
    if (tab !== selectedTab) {
      setItemList([]); // Clear previous data immediately
      setTotalCount(0);
      setloading(true); // Show loading state
      setPageNumber(1); // Reset to first page
      setSelectedTab(tab); // This will trigger useEffect to fetch new data
      ClearFilter();
    }
  };

  const initialStatedata = { stateId: 0, stateName: "" };
  const [States, setStates] = useState([initialStatedata]);
  const { openDialog_Message } = useAppDialog()
  
  const fetchStateData = () => {
    apiClient("/States/getStates", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
          .then((responseJson) => {
      if (!responseJson) return;
      setStates(responseJson.data);
    });
  };

  // Get Partners List API
  const getPartnersList = () => {
    apiClient("/customer/getPartnersList", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((responseJson) => {
        if (!responseJson) return;
        
        if (responseJson.data && responseJson.data.length > 0) {
          setPartners(responseJson.data);
          console.log("Partners data:", responseJson.data);
        } else {
          setPartners([]);
          console.log("No partners data available");
        }
      })
      .catch((error) => {
        console.error("Error fetching partners:", error);
        setPartners([]);
      });
  };

  // Refresh Partners List
  const refreshPartnersList = () => {
    getPartnersList();
  };

  const fetchData = () => {
    setloading(true); // Show loading state
    
    const requestBody: any = {
      pageSize: pageSize,
      pageNumber: pageNumber,
      field: sortModel?.[0]?.field || '',
      sort: sortModel?.[0]?.sort || '',
      filterModel: filterModel,
      policyNumber: policyNumber,
      insuredName: insuredName,
      invoiceNumber: invoiceNumber,
      selectedHomeState: selectedHomeState,
      selectedPartner: selectedPartner,
      isSentToMisc: selectedTab === 'SentToMISC',
    };

    apiClient(`/customer/getTransactions`, {
      method: "POST",
      headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
      }),
      body: JSON.stringify(requestBody),
    })
         .then(responseJson => {
       if (!responseJson) return

       if (responseJson.data && responseJson.data.getCustomerTransactions_Respdata.length > 0) {
         setItemList(responseJson.data.getCustomerTransactions_Respdata);
         setTotalCount(responseJson.data.totalCount);
         
                   // Use partners data instead of extracting from transactions
          if (partners.length > 0) {
            const partnerNames = partners.map(partner => partner.customerName);
            setClients(partnerNames.sort());
          } else {
            setClients([]);
          }
         
         setloading(false);
       } else {
         setItemList([]);
         setTotalCount(0);
         setloading(false);
       }

       // Update summary data from API response
       if (responseJson.data) {
         setSummaryData({
           pastDue: responseJson.data.pastDueCount || 0,
           dueToday: responseJson.data.dueTodayCount || 0,
           dueInNext10Days: responseJson.data.dueNext10DaysCount || 0,
           totalOutstanding: responseJson.data.outstandingTotalCount || 0,
         });
       }
     })
    .catch(error => {
      setItemList([]);
      setTotalCount(0);
      setloading(false);
    });
  };

  const handleClose = () => {
    setOpenDoc(false);
    setViewOnlyDoc(false);
    fetchData();
  };
  const handleSendMessage = async (custPolId: number, status?: string, viewOnly?: boolean) => {
    try {
      setloading(true);

      openDialog_Message({
        custPolId: String(custPolId),
        viewOnly: viewOnly
      }).then((res: DialogResponse) => {
        if (res.dialogResult === DialogResult.OK) {
          // Message sent successfully
        }
        return res;
      });
      setloading(false);

    } catch (error) {
      setloading(false);
    }
  };

  const UploadDocument = (id: any, isViewOnly: boolean = false) => {
    setID(id);
    setViewOnlyDoc(isViewOnly);
    setOpenDoc(true);
  }

  const SentToMisc = async (customerPolicyId: any) => {
    const [uploadedRes, revertedRes] = await Promise.all([
      apiClient(`/customer/getUploadedDocuments?customerPolicyId=${customerPolicyId}`, {
        method: "GET",
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        })
      }),
      apiClient(`/customer/getRevertedDocuments?customerPolicyId=${customerPolicyId}`, {
        method: "GET",
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        })
      })
    ]);
    
    if (!uploadedRes && !revertedRes) return;
    
    const uploadedDocuments = uploadedRes?.data ?? [];
    const revertedDocuments = revertedRes?.data ?? [];
    
    const hasUploadedDocs = uploadedDocuments.some((doc: UploadedDocumentType) => doc.documentTypeId !== 0);
    const hasRevertedDocs = revertedDocuments.some((doc: UploadedDocumentType) => doc.documentTypeId !== 0);
    
    if (!hasUploadedDocs && !hasRevertedDocs) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Please upload at least one document before sending to MISC',
        confirmButtonText: 'OK'
      });
      return;
    }

    Swal.fire({
      title: 'Send to MISC',
      text: 'Are you sure you want to send this transaction to MISC?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#007BFF',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      padding: '20px',
      backdrop: true,
      customClass: {
          popup: 'custom-swal-popup',
          confirmButton: 'btn-radius',
          cancelButton: 'btn-radius',
      },
      width: '500px',
  })
  .then(async (result: { isConfirmed: any; }) => {
    if (result.isConfirmed) {
      try {
        // If there are reverted documents, convert them to uploaded documents first
        if (hasRevertedDocs) {
          await apiClient(`/customer/convertRevertedToUploaded?customerPolicyId=${customerPolicyId}`, {
            method: "GET",
            headers: new Headers({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            })
          });
        }       
        // Now send to MISC
        const res = await apiClient(`/customer/SentToMisc?customerPolicyId=${customerPolicyId}`, {
          method: "GET",
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          })
        });
        
        if (!res) return;
        if (res.data != null) {
          Swal.fire({
            title: 'Success!',
            text: 'The transaction has been successfully sent to MISC.',
            icon: 'success',
            confirmButtonColor: '#007BFF',
            confirmButtonText: 'OK',
            padding: '20px',
            customClass: {
              popup: 'custom-swal-popup',
              confirmButton: 'btn-radius',
            },
            width: '400px',
          }).then((result) => {
            fetchData();
          });
        }
      } catch (error) {
        console.error('Error sending to MISC:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'An error occurred while sending to MISC. Please try again.',
          confirmButtonText: 'OK'
        });
      }
    }
  });
  }

  const handleHomeStateChange = (e: SelectChangeEvent) => {
    const selectedValue = e.target.value;
    setSelectedHomeState(selectedValue);
  };

  const handlePolicyNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setPolicyNumber(inputValue);
  };

  const handleInsuredNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setInsuredName(inputValue);
  };

  const handleInvoiceNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setInvoiceNumber(inputValue);
  };

  const handlePartnerChange = (e: SelectChangeEvent) => {
    const selectedValue = e.target.value;
    setSelectedPartner(selectedValue);
  };

  function RunSearch() {
    setloading(true);
    fetchData();
  }

     function ClearFilter() {
     setloading(true);
     setSelectedHomeState('');
     setPolicyNumber('');
     setInsuredName('');
     setInvoiceNumber('');
     setSelectedPartner('');
     setFilterModel({ items: [], linkOperator: GridLinkOperator.And });
}

  const handleFilterModelChange = (newFilterModel: GridFilterModel) => {
    setFilterModel(newFilterModel);
    setPageNumber(1); // Reset to first page when filter changes
  };

  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setSortModel(newSortModel);
    setPageNumber(1); // Reset to first page when sort changes
  };

      const handleExport = async () => {
       try {
         setloading(true); // Add loading state for export
         
        // Export all filtered data
      const requestBody: any = {
        pageSize: 10000, // Large number to get all data
        pageNumber: 1,
        field: sortModel?.[0]?.field || '',
        sort: sortModel?.[0]?.sort || '',
        filterModel: filterModel,
        policyNumber: policyNumber,
        insuredName: insuredName,
        invoiceNumber: invoiceNumber,
        selectedHomeState: selectedHomeState,
        selectedPartner: selectedPartner,
        isSentToMisc: selectedTab === 'SentToMISC',
      };

      const response = await apiClient(`/customer/getTransactions`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(requestBody),
      });

      if (!response || !response.data || !response.data.getCustomerTransactions_Respdata) {
        Swal.fire({
          icon: 'error',
          title: 'Export Failed',
          text: 'No data available to export',
          confirmButtonText: 'OK'
        });
        return;
      }

      const exportData = response.data.getCustomerTransactions_Respdata;

      // Show confirmation for large datasets
      if (exportData.length > 1000) {
        const confirmResult = await Swal.fire({
          icon: 'warning',
          title: 'Large Dataset',
          text: `You are about to export ${exportData.length} records. This may take a moment. Continue?`,
          showCancelButton: true,
          confirmButtonColor: '#28a745',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Continue',
          cancelButtonText: 'Cancel',
        });

                          if (!confirmResult.isConfirmed) {
            return;
          }
      }

             // Define headers for export - match UI display logic
       const headers = partners.length > 1 ? [
        'Filing Due Date',
         'Client',
         'Invoice Number',
         'Insured Name', 
         'Policy Number',
         'Home State',
         'Transaction Type',
         'Invoice Date',
         'Policy Effective Date',
         'Policy Expiration Date',
         'Gross Premium'
       ] : [
        'Filing Due Date',
        'Invoice Number',
        'Insured Name', 
        'Policy Number',
        'Home State',
        'Transaction Type',
        'Invoice Date',
        'Policy Effective Date',
        'Policy Expiration Date',
        'Gross Premium'
      ];

             // Prepare data for export - match UI display logic
       const exportRows = exportData.map((item: Transaction) => {
         if (partners.length > 1) {
           return [
             item.dueDate ? safeMoment(item.dueDate).format("MM/DD/YYYY") : '',
             item.client || '',
             item.invoiceNumber || '',
             item.insuredName || '',
             item.policyNumber || '',
             item.homeState || '',
             item.transactionTypeName || '',
             item.invoiceDate ? safeMoment(item.invoiceDate).format("MM/DD/YYYY") : '',
             item.effectiveDate ? safeMoment(item.effectiveDate).format("MM/DD/YYYY") : '',
             item.policyExpDate ? safeMoment(item.policyExpDate).format("MM/DD/YYYY") : '',
             item.grossPremium ? formatPrice(item.grossPremium.replace(/[,\$]/g, "").trim()) : ''
           ];
         } else {
          return [
            item.dueDate ? safeMoment(item.dueDate).format("MM/DD/YYYY") : '',
            item.invoiceNumber || '',
            item.insuredName || '',
            item.policyNumber || '',
            item.homeState || '',
            item.transactionTypeName || '',
            item.invoiceDate ? safeMoment(item.invoiceDate).format("MM/DD/YYYY") : '',
            item.effectiveDate ? safeMoment(item.effectiveDate).format("MM/DD/YYYY") : '',
            item.policyExpDate ? safeMoment(item.policyExpDate).format("MM/DD/YYYY") : '',
            item.grossPremium ? formatPrice(item.grossPremium.replace(/[,\$]/g, "").trim()) : ''
          ];
        }
      });

      // Combine headers and data
      const exportArray = [headers, ...exportRows];

      // Generate filename with timestamp
      const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
      const filename = `CustomerTransactions_${exportData.length}_${timestamp}.xlsx`;

            // Export to Excel
      await writeXlsxFile(exportArray, filename);

      // Show success popup
      Swal.fire({
        icon: 'success',
        title: 'Export Successful',
        text: `All data has been exported.`,
        confirmButtonText: 'OK'
      });

             } catch (error) {
          console.error('Export error:', error);
          Swal.fire({
            icon: 'error',
            title: 'Export Failed',
            text: 'An error occurred while exporting the data',
            confirmButtonText: 'OK'
          });
        } finally {
          setloading(false); // Always clear loading state
        }
  };



  const columns: GridColDef[] = [
    {
      field: 'customerPolicyId', 
      hide: true,
    },
    ...(selectedTab === 'Outstanding' ? [{
      field: 'dueDate',
      headerName: 'Filing Due Date',
      type: 'date',
      flex: 1,
      minWidth: 140,
      valueGetter: (params) => {
        if (!params.value) return null;
        return new Date(params.value);
      },
      renderCell: (params) => {
        const dueDate = params.row.dueDate;
        const isPastDue = dueDate && safeMoment(dueDate).isBefore(moment(), 'day');
        return (
          <div style={{ color: isPastDue ? '#d32f2f' : 'inherit'}}>
            {(dueDate != null && dueDate != '') ? safeMoment(dueDate).format("MM/DD/YYYY") : ""}
          </div>
        );
      }
    } as GridColDef] : []),
         ...(partners.length > 1 ? [{ 
       field: 'client', 
       headerName: 'Client',
       flex: 1,
       minWidth: 200,
     } as GridColDef] : []),
    { 
      field: 'invoiceNumber', 
      headerName: 'Invoice Number',
      flex: 1,
      minWidth: 160,
    },
    { 
      field: 'insuredName', 
      headerName: 'Insured Name',
      flex: 1,
      minWidth: 155,
    },
    { 
      field: 'policyNumber', 
      headerName: 'Policy Number',
      flex: 1,
      minWidth: 160,
    },
    { 
      field: 'homeState', 
      headerName: 'Home State',
      flex: 1,
      minWidth: 120,
    },
    { 
      field: 'transactionTypeName', 
      headerName: 'Transaction Type',
      flex: 1,
      minWidth: 175,
    },
    { 
      field: 'invoiceDate', 
      headerName: 'Inv Date',
      type: 'date',
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => {
        if (!params.value) return null;
        return new Date(params.value);
      },
      renderCell: (params) =>
      (
        <div>
          {(params.row.invoiceDate != null && params.row.invoiceDate != '') ? safeMoment(params.row.invoiceDate).format("MM/DD/YYYY") : ""}
        </div>
      )
    },
    { 
      field: 'effectiveDate', 
      headerName: 'Policy Eff Date',
      type: 'date',
      flex: 1,
      minWidth: 165,
      valueGetter: (params) => {
        if (!params.value) return null;
        return new Date(params.value);
      },
      renderCell: (params) =>
      (
        <div>
          {(params.row.effectiveDate != null && params.row.effectiveDate != '') ? safeMoment(params.row.effectiveDate).format("MM/DD/YYYY") : ""}
        </div>
      )
    },
    { 
      field: 'policyExpDate', 
      headerName: 'Policy Exp Date',
      type: 'date',
      flex: 1,
      minWidth: 165,
      valueGetter: (params) => {
        if (!params.value) return null;
        return new Date(params.value);
      },
      renderCell: (params) =>
      (
        <div>
          {(params.row.policyExpDate != null && params.row.policyExpDate != '') ? safeMoment(params.row.policyExpDate).format("MM/DD/YYYY") : ""}
        </div>
      )
    },
    {
      field: 'grossPremium',
      headerName: 'Gross Premium',
      flex: 1,
      minWidth: 145,
      renderCell: (params) => {
        let grossPremium = params.value || '';
        let cleanedValue = grossPremium.replace(/[,\$]/g, "").trim();

        if (cleanedValue.startsWith("(") && cleanedValue.endsWith(")")) {
          cleanedValue = "-" + cleanedValue.slice(1, -1);
        }

        const numericValue = parseFloat(cleanedValue);

        return isNaN(numericValue) ? grossPremium : `${formatPrice(numericValue.toString())}`;
      }
    },
    {
      field: 'documentUpload',
      headerName: 'Document Upload',
      flex: 1,
      minWidth: 190,
      sortable: false, 
      filterable: false, 
      disableColumnMenu: true,
      renderCell: (params) => (
        <>
          {selectedTab === 'SentToMISC' ? (
            /* View only icons for SentToMISC tab */
            <Box sx={{display: 'flex', width: '100%', gap: 1 }}>
              <Tooltip
                title="View Document"
                arrow
                PopperProps={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 10],
                      },
                    },
                  ],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: '#333',
                      color: '#fff',
                      fontSize: '14px',
                      padding: '8px 12px',
                      borderRadius: '6px',
                      boxShadow: 2,
                    },
                  },
                  arrow: {
                    sx: {
                      color: '#333',
                    },
                  },
                }}
              >
                <IconButton
                  onClick={() => { UploadDocument(params.row.customerPolicyId, true) }}
                  sx={{
                    width: 40,
                    height: 40,
                    color: '#FFF',
                    backgroundColor: '#2099d2',
                    '&:hover': {
                      backgroundColor: '#162f3c',
                      color: '#FFF',
                    },
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="3"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </IconButton>
              </Tooltip>
              {params.row.hasMessage && (
                <Tooltip
                  title="View Messages"
                  arrow
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, 10],
                        },
                      },
                    ],
                  }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#333',
                        color: '#fff',
                        fontSize: '14px',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        boxShadow: 2,
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#333',
                      },
                    },
                  }}
                >
                  <IconButton
                    onClick={(evt) => {
                      evt.preventDefault()
                      evt.stopPropagation()
                      handleSendMessage(params.row.customerPolicyId, params.row.status, true)
                    }}
                    sx={{
                      width: 40,
                      height: 40,
                      color: '#FFF',
                      backgroundColor: '#2099d2',
                      '&:hover': {
                        backgroundColor: '#162f3c',
                        color: '#FFF',
                      },
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                    </svg>
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          ) : (
            /* All icons for Outstanding tab */
            <>
              <Tooltip
                title="Send to MISC"
                arrow
                PopperProps={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 10],
                      },
                    },
                  ],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: '#333',
                      color: '#fff',
                      fontSize: '14px',
                      padding: '8px 12px',
                      borderRadius: '6px',
                      boxShadow: 2,
                    },
                  },
                  arrow: {
                    sx: {
                      color: '#333',
                    },
                  },
                }}
              >
                <IconButton
                  onClick={() => { SentToMisc(params.row.customerPolicyId) }}
                  sx={{
                    width: 40,
                    height: 40,
                    color: '#FFF',
                    marginRight: '8px',
                    backgroundColor: '#2099d2',
                    '&:hover': {
                      backgroundColor: '#162f3c',
                      color: '#FFF',
                    },
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 13L9 17L19 7"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </IconButton>
              </Tooltip>
              <Tooltip
                title="Upload Document"
                arrow
                PopperProps={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 10],
                      },
                    },
                  ],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: '#333',
                      color: '#fff',
                      fontSize: '14px',
                      padding: '8px 12px',
                      borderRadius: '6px',
                      boxShadow: 2,
                    },
                  },
                  arrow: {
                    sx: {
                      color: '#333',
                    },
                  },
                }}
              >
                <IconButton
                  onClick={() => { UploadDocument(params.row.customerPolicyId) }}
                  sx={{ 
                    color: '#FFF',
                    backgroundColor: '#2099d2',
                    '&:hover': {
                      backgroundColor: '#162f3c',
                      color: '#FFF'
                    }
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25M12.75 6L9 2.25M9 2.25L5.25 6M9 2.25V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </IconButton>
              </Tooltip>
              {user?.isSIPAccess &&
                <Tooltip
                  title="SIP"
                  arrow
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, 10],
                        },
                      },
                    ],
                  }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#333',
                        color: '#fff',
                        fontSize: '14px',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        boxShadow: 2,
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#333',
                      },
                    },
                  }}
                >
                  <Link to={`${BaseStateInformationPortalUrl}/${params.row.state}.aspx#PolicyDocuments`} target="_blank" style={{
                    textDecoration: "none",
                    borderRadius: '100%',
                    marginLeft: '8px',
                  }}>
                    <Box sx={{
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center',
                      width: '40px',
                      height: '40px',
                      borderRadius: '100%',
                      color: '#FFF',
                      backgroundColor: '#2099d2',
                      '&:hover': {
                        backgroundColor: '#162f3c',
                        color: '#FFF'
                      }
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z"/>
                        <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z"/>
                        <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                      </svg>
                    </Box>
                  </Link>
                </Tooltip>
              }
              
              {params.row.hasMessage ?
                <Tooltip
                  title="Send Message"
                  arrow
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, 10],
                        },
                      },
                    ],
                  }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#333',
                        color: '#fff',
                        fontSize: '14px',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        boxShadow: 2,
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#333',
                      },
                    },
                  }}
                >
                  <IconButton
                    onClick={(evt) => {
                      evt.preventDefault()
                      evt.stopPropagation()
                      handleSendMessage(params.row.customerPolicyId, params.row.status)
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-envelope ms-1" viewBox="0 0 18 18">
                      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                    </svg>
                  </IconButton>
                </Tooltip>
                : null
              }
            </>
          )}
        </>
      ),
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          input::placeholder {
            color: #333;
            opacity: 1;
          }
        `}
      </style>
      <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
        {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
      </div>
      <Box sx={{ width: '100%', paddingBottom: '10px' }} className="customer-header">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start',
          marginBottom: '20px'
        }}>
          {/* Left side with Welcome message */}
          <Box>
            <Typography 
              variant="h4" 
              component="h1" 
              sx={{ 
                fontSize: '28px',
                fontWeight: 'normal',
                marginBottom: '8px'
              }}
            >
              Welcome <strong>{currentUser?.userFirstName} {currentUser?.userlastName}</strong>!
            </Typography>
              
            <Typography 
              variant="body1" 
              sx={{ 
                fontSize: '16px',
                color: '#555'
              }}
            >
              Please upload your filing documents below by selecting the <strong>Document Upload</strong> button to the right of each transaction.
            </Typography>
          </Box>

          {/* Right side with Summary Panel - Only show in Outstanding tab */}
          {selectedTab === 'Outstanding' && (
            <TableContainer
              component={Paper}
              sx={{
                maxWidth: 250,
                display: 'inline-block',
                borderRadius: '4px',
                overflow: 'hidden',
              }}
            >
              <Table
                size="small"
                sx={{
                  borderCollapse: 'collapse',
                  '& td': {
                    border: '4px solid white !important',
                    padding: '4px 10px',
                    textAlignLast: 'start'
                  },
                }}
              >
                <TableBody>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        backgroundColor: '#b3d1ff',
                        color: '#d32f2f',
                        width: '70%',
                      }}
                    >
                      Past Due:
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 600,
                        backgroundColor: '#e6f0ff',
                        color: '#d32f2f',
                      }}
                    >
                      {summaryData.pastDue}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        backgroundColor: '#b3d1ff',
                        color: '#000',
                        width: '70%',
                      }}
                    >
                      Due Today:
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 600,
                        backgroundColor: '#e6f0ff',
                        color: '#000',
                      }}
                    >
                      {summaryData.dueToday}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        backgroundColor: '#b3d1ff',
                        color: '#000',
                        width: '70%',
                      }}
                    >
                      Due in Next 10 Days:
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 600,
                        backgroundColor: '#e6f0ff',
                        color: '#000',
                      }}
                    >
                      {summaryData.dueInNext10Days}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        backgroundColor: '#b3d1ff',
                        color: '#000',
                        width: '70%',
                      }}
                    >
                      Total Outstanding:
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 600,
                        backgroundColor: '#e6f0ff',
                        color: '#000',
                      }}
                    >
                      {summaryData.totalOutstanding}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>

        {/* Tabs Section */}
        <Box  sx={{ display: 'flex', justifyContent: 'center', gap: 10, marginBottom: '20px' }}>
          <div className="text-center">
          <Button
            variant={selectedTab === 'Outstanding' ? 'contained' : 'outlined'}
            onClick={() => handleTabChange('Outstanding')}
            sx={{
              borderRadius: '25px',
              padding: '10px 40px',
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: 500,
              backgroundColor: selectedTab === 'Outstanding' ? '#2099d2' : 'transparent',
              color: selectedTab === 'Outstanding' ? '#fff' : '#2099d2',
              borderColor: '#2099d2',
              '&:hover': {
                backgroundColor: selectedTab === 'Outstanding' ? '#1a7fb3' : 'rgba(32, 153, 210, 0.1)',
                borderColor: '#2099d2',
              },
            }}
          >
            Outstanding
          </Button>
          </div>
          <div className="text-center">
          <Button
            variant={selectedTab === 'SentToMISC' ? 'contained' : 'outlined'}
            onClick={() => handleTabChange('SentToMISC')}
            sx={{
              borderRadius: '25px',
              padding: '10px 40px',
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: 500,
              backgroundColor: selectedTab === 'SentToMISC' ? '#2099d2' : 'transparent',
              color: selectedTab === 'SentToMISC' ? '#fff' : '#2099d2',
              borderColor: '#2099d2',
              '&:hover': {
                backgroundColor: selectedTab === 'SentToMISC' ? '#1a7fb3' : 'rgba(32, 153, 210, 0.1)',
                borderColor: '#2099d2',
              },
            }}
          >
            Sent to MISC
          </Button>
          </div>
        </Box>
      </Box>

      {/* Filter Section */}
      <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 2,
            ml: '186px', // Adds margin-left
          }}
        >
          {/* Home State Dropdown */}
          <FormControl size="small" className="select-input-border text-input-box" sx={{ minWidth: 200 }}>
            <InputLabel id="home-state-label" sx={{ top: '3px' }}>Home State</InputLabel>
            <Select
              labelId="home-state-label"
              id="home-state"
              value={selectedHomeState}
              label="Home State"
              onChange={handleHomeStateChange}
            >
              <MenuItem value="">
                <em>Home State</em>
              </MenuItem>
              {States.map((state) => (
                <MenuItem key={state.stateId} value={state.stateId}>
                  {state.stateName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Policy Number Input */}
          <TextField
            name="PolicyNumber"
            size="small"
            className="select-input-border text-input-box"
            sx={{ minWidth: 200 }}
            value={policyNumber}
            label="Policy Number"
            onChange={handlePolicyNumberChange}
            type="text"
            variant="outlined"
            id="policyNumber"
            InputLabelProps={{ sx: { top: '3px' } }}
          />

          {/* Insured Name Input */}
          <TextField
            name="InsuredName"
            size="small"
            className="select-input-border text-input-box"
            sx={{ minWidth: 200 }}
            value={insuredName}
            label="Insured Name"
            onChange={handleInsuredNameChange}
            type="text"
            variant="outlined"
            id="insuredName"
            InputLabelProps={{ sx: { top: '3px' } }}
          />

          {/* Invoice Number Input */}
          <TextField
            name="InvoiceNumber"
            size="small"
            className="select-input-border text-input-box"
            sx={{ minWidth: 200 }}
            value={invoiceNumber}
            label="Invoice Number"
            onChange={handleInvoiceNumberChange}
            type="text"
            variant="outlined"
            id="invoiceNumber"
            InputLabelProps={{ sx: { top: '3px' } }}
          />
            {/* Partner Dropdown */}
          {partners.length > 1 && (
            <FormControl size="small" className="select-input-border text-input-box" sx={{ minWidth: 200 }}>
              <InputLabel id="select-client-label" sx={{ top: '3px' }}>Select Client</InputLabel>
              <Select
                labelId="select-client-label"
                id="select-client"
                value={selectedPartner}
                label="Select Client"
                onChange={handlePartnerChange}
              >
                <MenuItem value="">
                  <em>Select Client</em>
                </MenuItem>
                {partners.map((partner) => (
                  <MenuItem key={partner.partnersId} value={partner.partnersId}>
                    {partner.customerName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {/* Search Button */}
          <div>
            <button
              type="button"
              style={{
                width: '100px',
                height: '40px',
                backgroundColor: '#2099d2',
                color: '#fff',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
              }}
              onClick={() => {
                RunSearch();
              }}
              className="active-btn1-blue-tabs"
            >
              Search
            </button>
          </div>

          {/* Clear Button */}
          <div>
            <button
              type="button"
              style={{
                width: '100px',
                height: '40px',
                backgroundColor: '#f5f5f5',
                color: '#333',
                border: '1px solid #ccc',
                borderRadius: '20px',
                cursor: 'pointer',
              }}
              onClick={() => {
                ClearFilter();
              }}
              className="btn-clear-refresh btn"
            >
              Clear
            </button>
          </div>

                     {/* Refresh Button */}
           <div>
             <button
               type="button"
               style={{
                 width: '100px',
                 height: '40px',
                 backgroundColor: '#f5f5f5',
                 color: '#333',
                 border: '1px solid #ccc',
                 borderRadius: '20px',
                 cursor: 'pointer',
               }}
               onClick={() => {
                 window.location.reload();
               }}
               className="btn-clear-refresh btn"
             >
               Refresh
             </button>
           </div>

                     {/* Export Button */}
           <div>
             <button
               type="button"
               style={{
                 width: '100px',
                 height: '40px',
                 backgroundColor: '#2099d2',
                 color: '#fff',
                 border: 'none',
                 borderRadius: '20px',
                 cursor: 'pointer',
               }}
               onClick={handleExport}
               className="active-btn1-blue-tabs"
             >
               Export
             </button>
           </div>


      </Box>


      <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
        {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
      </div>
      <Box className="shadow rounded" sx={{ height: 'calc(100vh - '+(headerHeight + 70)+'px)', width: '100%', backgroundColor: '#FFF', padding: '0 !important', overflow: 'hidden', border: '1px solid #8cc5e6' }}>
        <DataGridPro
          getRowId={(r) => r.rowNum}
          classes={{
            columnHeaders: "MuiDataGridPro-columnHeaders custom-header",
            virtualScroller: "MuiDataGridPro-virtualScroller",
          }}
          rows={itemList}
          columns={columns}
          rowCount={totalCount}
          pageSize={pageSize}
          pagination
          paginationMode="server" // Enable server-side pagination
          onPageChange={(newPage: number) => setPageNumber(newPage + 1)} // Trigger page change
          rowsPerPageOptions={[10, 25, 50]}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          filterMode="server"
          filterModel={filterModel}
          onFilterModelChange={handleFilterModelChange}
          sortingMode="server"
          sortingOrder={['asc', 'desc']}
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          disableSelectionOnClick
          //loading={loading} // Show loading indicator during fetch
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              lineHeight: "normal",
            },
            fontFamily: "'Proxima Nova', sans-serif",
            border: "0px",
            fontSize: "16px",
          }}

        />
      </Box>
      <AddDocument open={openDoc} handleClose={handleClose} customerPolicyId={ID} currentUser={currentUser} viewOnly={viewOnlyDoc}></AddDocument>
    </Box>

  );
};